import React, { useState } from "react";

const AddComments = ({ mediaIndex, onAddComment }) => {
  const [newComment, setNewComment] = useState("");

  const handleAddComment = () => {
    if (newComment.trim()) {
      onAddComment(mediaIndex, newComment.trim());
      setNewComment("");
    }
  };

  return (
    <div className="add-comment">
      <input
        type="text"
        value={newComment}
        placeholder="Add a comment..."
        onChange={(e) => setNewComment(e.target.value)}
        className="comment-input"
      />
      <button onClick={handleAddComment} className="add-comment-button">
        Add
      </button>
    </div>
  );
};

export default AddComments;
